import React, { Component } from "react";
import { connect } from "react-redux";
import docActions from "../../redux/doc/doc.action";
import DocumentationImg from "../../_resources/image/catalogue_onyx.png";
import TxtConnexion from "../../_resources/image/txt_connexion.png";

class Doc extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      transition: 0,
    };
  }

  downloadFile = () => {
    const { dispatch } = this.props
    dispatch(docActions.getDoc("onyx", "fr"))
  } 

  render() {
    const { noConnexion, t } = this.props;
    const content = {
      button: t('all.button.download')
    }
    return (
      <div className={"documentation-container"} style={{ zIndex: 1 }} itemScope itemType="https://schema.org/CreativeWork">
        <div className={"catalogue"}>
          <img itemProp="image" src={DocumentationImg} height={`${window.innerHeight / 2}px`} alt="documentation"/>
        </div>
        <div className={"download-documentation"}>
          {!noConnexion && (
            <div className={"image-container"}>
              <img src={TxtConnexion} alt="onyx"/>
            </div>
          )}
          <div className={"button-download"}>
          <button itemProp="subjectOf" onClick={this.downloadFile}>{content.button}</button>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state: any) {
  const { doc } = state;

  return {
    doc,
  };
}

const connectedDoc = connect(mapStateToProps)(Doc);
export default connectedDoc;
